import { FC } from 'react'

import styles from './portal-layout.module.scss'

type FormContainerProps = {
  autoId?: string
}
export const FormContainer: FC<FormContainerProps> = ({ children, autoId }) => {
  return (
    <div className={styles['account-portal-form-padding']} data-auto-id={autoId}>
      {children}
    </div>
  )
}
